import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'
import { setCurrentClient } from '../../actions/client'
import { Text, Image, Heading, Flex } from '@homebotapp/hb-react-component-catalog'
import notFoundSrc from 'assets/homes/img/not_found.svg'

interface NotFoundProps {
  resetState?: boolean
  fullHeight?: boolean
}

export const MSG = defineMessages({
  head: {
    id: 'Application.notFound.headline',
    defaultMessage: 'Page not found'
  },
  body: {
    id: 'Application.notFound.bodyText',
    defaultMessage: 'The page you’re looking for doesn’t exist.'
  }
})

export const NotFound = ({ resetState, fullHeight }: NotFoundProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()

  useEffect(() => {
    if (resetState) {
      dispatch(setCurrentClient(null))
    }
  }, [dispatch, resetState])

  return (
    <Flex
      padding={4}
      align='center'
      justify='center'
      direction='column'
      textAlign='center'
      height={fullHeight ? '100vh' : ''}
      minHeight='calc(60vh - #{$global-nav-height})'
    >
      <Image mb={8} src={notFoundSrc} alt='Not found' />
      <Heading fontWeight='semibold'>{intl.formatMessage(MSG.head)}</Heading>
      <Text maxWidth='30rem'>{intl.formatMessage(MSG.body)}</Text>
    </Flex>
  )
}
